// extracted by mini-css-extract-plugin
var _1 = "section-SJDsq";
export { _1 as "section" }
